import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import List from './list';

const Component = () => (
  <Switch>
    <Route exact path="/devices"><List /></Route>
    <Redirect to="/devices" />
  </Switch>
);

export default Component;
